import React from 'react'
import GetIcon from '../../../../utils/Icon'

function Tab4() {
    return (
        <div
            className="row  m-0"
            style={{ padding: "8px", borderRadius: "5px" }}
        >
            <div className="col-12">

                <div className="tableLabel">
                    <div>

                        <div className=' d-flex ' style={{ gap: '90px' }} >
                            <div className='part-1'>
                                <div>
                                    <p className="mb-1" style={{ color: "#1E1E1E", fontWeight: '500', fontSize: "14px" }}>
                                        Related
                                    </p>
                                </div>

                                <div className="mt-2 d-flex gap-4 ">

                                    <div className="d-flex align-items-center gap-3 ">
                                        <div className="invoice-button">
                                            <span className="invoice-icon">
                                                <GetIcon iconName="FaPlus" size={10} />
                                            </span>
                                            <span className="invoice-label mt-1">Create Sales Invoice</span>
                                        </div>

                                        <div className="invoice-count">
                                            3
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center gap-3 ">
                                        <div className="invoice-button">
                                            <span className="invoice-icon">
                                                <GetIcon iconName="FaPlus" size={10} />
                                            </span>
                                            <span className="invoice-label mt-1">Create Packing Slip</span>
                                        </div>

                                        <div className="invoice-count">
                                            6
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center gap-3">
                                        <div className="invoice-button">
                                            <span className="invoice-icon">
                                                <GetIcon iconName="FaPlus" size={10} />
                                            </span>
                                            <span className="invoice-label mt-1">Create Delivery Trip</span>
                                        </div>

                                        <div className="invoice-count">
                                            5
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className='part-2 ' style={{marginLeft:'5%'}}>
                                <div>
                                    <p className="mb-1 " style={{ color: "#1E1E1E", fontWeight: '500', fontSize: "14px" }}>
                                    Returns
                                    </p>
                                </div>

                                <div className="mt-2 d-flex gap-5 ">

                                    <div className="d-flex align-items-center gap-3 ">
                                        <div className="invoice-button">
                                            <span className="invoice-icon">
                                                <GetIcon iconName="FaPlus" size={10} />
                                            </span>
                                            <span className="invoice-label mt-1">Create Stock Entry</span>
                                        </div>

                                        <div className="invoice-count">
                                            3
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>
                        <div className='mt-4 d-flex ' style={{ gap: '108px' }} >
                            <div className='part-1'>
                                <div>
                                    <p className="mb-1" style={{ color: "#1E1E1E", fontWeight: '500', fontSize: "14px" }}>
                                        Reference
                                    </p>
                                </div>

                                <div className="mt-2 d-flex gap-4 ">

                                    <div className="d-flex align-items-center gap-3 ">
                                        <div className="invoice-button">
                                            <span className="invoice-icon">
                                                <GetIcon iconName="FaPlus" size={10} />
                                            </span>
                                            <span className="invoice-label mt-1">Create Sales Order</span>
                                        </div>

                                        <div className="invoice-count">
                                            3
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center gap-3 ">
                                        <div className="invoice-button">
                                            <span className="invoice-icon">
                                                <GetIcon iconName="FaPlus" size={10} />
                                            </span>
                                            <span className="invoice-label mt-1">Create Shipment</span>
                                        </div>

                                        <div className="invoice-count">
                                            6
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center gap-3">
                                        <div className="invoice-button">
                                            <span className="invoice-icon">
                                                <GetIcon iconName="FaPlus" size={10} />
                                            </span>
                                            <span className="invoice-label mt-1">Quality Inspection</span>
                                        </div>

                                        <div className="invoice-count">
                                            5
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className='part-2' style={{marginLeft:'6%'}}>
                                <div>
                                    <p className="mb-1" style={{ color: "#1E1E1E", fontWeight: '500', fontSize: "14px" }}>
                                    Subscription
                                    </p>
                                </div>

                                <div className="mt-2 d-flex gap-4 ">

                                    <div className="d-flex align-items-center gap-3 ">
                                        <div className="invoice-button">
                                            <span className="invoice-icon">
                                                <GetIcon iconName="FaPlus" size={10} />
                                            </span>
                                            <span className="invoice-label mt-1">Auto Repeat</span>
                                        </div>

                                        <div className="invoice-count">
                                            3
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>
                        <div>
                            <div className='mt-4 d-flex mb-5 ' style={{ gap: '90px' }} >
                                <div className='part-1'>
                                    <div>
                                        <p className="mb-1" style={{ color: "#1E1E1E", fontWeight: '500', fontSize: "14px" }}>
                                        Internal Transfer
                                        </p>
                                    </div>

                                    <div className="mt-2 d-flex gap-4 ">

                                        <div className="d-flex align-items-center gap-3 ">
                                            <div className="invoice-button">
                                                <span className="invoice-icon">
                                                    <GetIcon iconName="FaPlus" size={10} />
                                                </span>
                                                <span className="invoice-label mt-1">Create Material Request</span>
                                            </div>

                                            <div className="invoice-count">
                                                3
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center gap-3 ">
                                            <div className="invoice-button">
                                                <span className="invoice-icon">
                                                    <GetIcon iconName="FaPlus" size={10} />
                                                </span>
                                                <span className="invoice-label mt-1">Create Purchase Order</span>
                                            </div>

                                            <div className="invoice-count">
                                                6
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center gap-3">
                                            <div className="invoice-button">
                                                <span className="invoice-icon">
                                                    <GetIcon iconName="FaPlus" size={10} />
                                                </span>
                                                <span className="invoice-label mt-1">Create Purchase Receipt</span>
                                            </div>

                                            <div className="invoice-count">
                                                5
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>



                    </div>


                </div>

            </div>

        </div>
    )
}

export default Tab4
